import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "crm:flex crm:h-full crm:justify-between crm:items-center crm:sm:gap-x-2 crm:md:gap-x-12" }
const _hoisted_2 = {
  class: "crm:flex crm:h-full",
  href: "./dashboard"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "crm:flex crm:h-full"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "crm:flex crm:gap-3 crm:sm:gap-3 crm:md:gap-3 crm:lg:gap-1 crm:xl:gap-1" }
const _hoisted_7 = { class: "crm:flex crm:flex-col crm:justify-center crm:items-center crm:relative" }
const _hoisted_8 = {
  key: 0,
  class: "crm:text-black crm:mt-1"
}
const _hoisted_9 = {
  key: 1,
  class: "crm:w-2 crm:h-2 crm:bg-red-600 crm:rounded-full crm:absolute crm:top-0 crm:right-3"
}
const _hoisted_10 = { class: "crm:flex crm:items-center crm:justify-between" }
const _hoisted_11 = {
  key: 0,
  class: "d-inline-block w-100 text-center font-italic"
}
const _hoisted_12 = { class: "list-group list-group-flush" }
const _hoisted_13 = { class: "crm:inline-block crm:w-full crm:text-center crm:cursor-pointer" }

import {computed, ref, inject, onMounted, reactive} from 'vue'
import AppPopoverAssistenza from "./AppPopoverAssistenza.vue";
import BaseAlertify from 'fallco-frontend-framework/src/vue/plugins/BaseAlertify/BaseAlertify.vue'
import BaseNotifica from "../components/BaseNotifica.vue";
import BasePopover from "../components/BasePopover.vue";
import {bell, logout, mobile_menu} from '../svg/svgs.js'

const logoEquoCompensoPreventivatore = 'img/crm_notarile/logo_equo_compenso_e_preventivatore.svg';

/**
 * Effettua la chiamata per recuperare la lista delle notifiche non lette
 * @returns {Promise<void>}
 */

export default {
  __name: 'TheNavbarTop',
  props: {
  /**
   * Mainame dell'utente connesso
   */
  mainname: {
    type: String,
    default: null
  },
  /**
   * nome dell'utente connesso
   */
  nome_utente: {
    type: String,
    default: null
  },
  /**
   * Se popolato indica che si è accettata la privacy policy del CRM
   */
  privacy: {
    type: String,
    default: null
  },
  /**
   * Se true si è connessi come un notaio
   */
  is_notaio: {
    type: Boolean,
    default: false
  },
  /**
   * se true l'utente risulta loggato
   */
  is_logged_in: {
    type: [Boolean, Number],
    default: false
  },
  /**
   * url del logo
   */
  logo: {
    type: String,
    default: null
  },
  /**
   * abilitazione features
   */
  features: {
    type: Object,
    default() {
      return {}
    }
  }
},
  emits: [
  /**
   * (usata nel mobile) emitta se deve mostrare la sidebar oppure no
   */
  'isShowSidebar'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc
 * Renderizza e gestisce la visualizzazione della navbar in alto contenente logo e navigazione a icone sulla destra
 */
const props = __props

const emits = __emit

/**
 * @inject {$AxiosClient} recupera la libreria per le chiamate ajax
 */
const $AxiosClient = inject('$AxiosClient');

const notifiche = ref(null)
const notificheLength = ref(0)

/**
 * @inject {isMobile} recupera il valore se siamo nella modalità mobile oppure no
 */
const isMobile = inject('isMobile');

const popOver = reactive({
  utente: false,
  notifiche: false
})

const isLogged = computed(() => {
  return props.is_logged_in
})

async function initNotifiche() {
  let getNotifiche = await $AxiosClient.post('Notifiche', 'getNotifiche', {non_lette: 1}, {messages: false});

  if (getNotifiche.esito === 'ok') {
    notificheLength.value = (getNotifiche.rows) ? (getNotifiche.rows).length : 0;
    notifiche.value = (getNotifiche.rows) ? (getNotifiche.rows).slice(0, 8) : null;
  }
}

/**
 * Imposta tutte le notifiche non lette come lette
 * @returns {Promise<void>}
 */
async function setTutteNotificheLette() {
  let setTutteNotificheLette = await $AxiosClient.post('Notifiche', 'setTutteNotificheLette');

  if (setTutteNotificheLette.esito === 'ok') {
    notifiche.value = null;
  }
}

/**
 * Setta la notifica cliccata come letta ed esegue il link della stessa
 * @param notifica
 * @returns {Promise<void>}
 */
async function apriNotifica(notifica) {
  let setNotificaLetta = await $AxiosClient.post('Notifiche', 'setNotificaLetta', {
    notifica_id: notifica.notifica_id,
    pratica_id: notifica.pratica_id
  }, {messages: 'error'});

  if (setNotificaLetta.esito === 'ok') {
    window.location = notifica.link_onclick;
    await initNotifiche();
  }
}

/**
 *
 * @param notifica_id
 */
function settaNotificaLetta(notifica_id) {
  notifiche.value.forEach((notifica, notificaKey) => {
    if(notifica_id === notifica.notifica_id) {
      notifiche.value.splice(notificaKey, 1);
    }
  })
}

/**
 * Esegue la chiamata per il logout
 * @returns {Promise<void>}
 */
async function logOut() {
  popOver.utente = false;
  isAlertifyLogOut.value = false;

  await $AxiosClient.post('Login', 'logout', null, {messages: 'error'})

  if (props.is_notaio) {
    window.location = './login'
  } else {
    window.location = './login_clienti'
  }
}

const isAlertifyLogOut = ref(false)

onMounted(() => {
  if (isLogged.value) {
    initNotifiche();
  }
})

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */
const $DesignSystem = inject('$DesignSystem')

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseAlertify, {
      "is-toggle": isAlertifyLogOut.value,
      "onUpdate:isToggle": _cache[0] || (_cache[0] = $event => ((isAlertifyLogOut).value = $event)),
      "onExe:callback": logOut
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createElementVNode("p", null, "Sicuro di voler uscire dall'applicazione ?", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-toggle"]),
    _createElementVNode("div", {
      class: _normalizeClass(["crm:bg-white crm:py-2 crm:px-4 crm:fixed crm:w-full crm:h-16 crm:shadow-md crm:top-0 crm:flex crm:justify-between crm:items-center", {'crm:z-[70]': !_unref(isMobile), 'crm:z-40': _unref(isMobile)}])
    }, [
      _createVNode(_component_base_icon, {
        icon: _unref(mobile_menu),
        class: "crm:lg:hidden",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (emits('isShowSidebar', true)), ["prevent"]))
      }, null, 8 /* PROPS */, ["icon"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", _hoisted_2, [
          (__props.logo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: 'public/resources/'+__props.logo,
                class: "img-fluid",
                height: "48",
                width: "160",
                loading: "lazy",
                alt: "logo crm notarile"
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true)
        ]),
        (__props.features.crm_full === false && __props.features.crm_light === true)
          ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
              _createElementVNode("img", {
                src: 'public/resources/'+logoEquoCompensoPreventivatore,
                class: "img-fluid",
                height: "48",
                width: "169",
                loading: "lazy",
                alt: "logo preventivi equo compenso"
              }, null, 8 /* PROPS */, _hoisted_5)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!__props.is_notaio || (__props.is_notaio && __props.features.crm_full))
          ? (_openBlock(), _createBlock(BasePopover, {
              key: 0,
              value: popOver.notifiche,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => ((popOver.notifiche) = $event)),
              "custom-classes": {link: 'crm:shadow-none! crm:p-0 crm:lg:py-[6px] crm:lg:px-[12px]', container: 'crm:flex crm:flex-col'}
            }, {
              cta: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_base_icon, {
                    icon: _unref(bell),
                    sizing: {width: _unref(isMobile) ? '25px': '20px', height: _unref(isMobile) ? '25px' : '20px'}
                  }, null, 8 /* PROPS */, ["icon", "sizing"]),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("small", _hoisted_8, "Notifiche"))
                    : _createCommentVNode("v-if", true),
                  (notifiche.value && notifiche.value.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createElementVNode("strong", { class: "text-primary" }, "Notifiche", -1 /* CACHED */)),
                  (notifiche.value && notifiche.value.length > 0)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (setTutteNotificheLette()), ["prevent"])),
                        class: "crm:underline! crm:lowercase crm:capitalize-first crm:font-normal crm:hover:text-primary"
                      }, " Segna tutte come lette "))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              body: _withCtx(() => [
                (!notifiche.value || notifiche.value.length < 1)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_11, "Non ci sono notifiche non lette"))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifiche.value, (notifica) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(BaseNotifica, {
                      notifica: notifica,
                      onApriNotifica: apriNotifica,
                      onSetNotificaLetta: settaNotificaLetta
                    }, null, 8 /* PROPS */, ["notifica"])
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              footer: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("a", {
                  href: "/notifiche",
                  class: "crm:text-center crm:inline-block crm:w-full crm:underline! crm:hover:text-primary"
                }, "Vedi tutte le notifiche", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value"]))
          : _createCommentVNode("v-if", true),
        _renderSlot(_ctx.$slots, "default"),
        (!_unref(isMobile))
          ? (_openBlock(), _createBlock(AppPopoverAssistenza, {
              key: 1,
              mainname: __props.mainname,
              "nome-utente": __props.nome_utente
            }, null, 8 /* PROPS */, ["mainname", "nome-utente"]))
          : _createCommentVNode("v-if", true),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              onClick: _cache[4] || (_cache[4] = _withModifiers($event => (isAlertifyLogOut.value = true), ["prevent"])),
              class: "crm:py-[6px]"
            }, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_base_icon, {
                  icon: _unref(logout),
                  stroke: _unref($DesignSystem).design_colors.primary
                }, null, 8 /* PROPS */, ["icon", "stroke"])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("small", { class: "crm:underline crm:text-primary! crm:inline-block crm:w-full crm:text-center crm:cursor-pointer crm:relative crm:top-[-5px]" }, "Effettua il logout", -1 /* CACHED */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}